export default {
  Private: 'private',
  SharedReadOnly: 'sharedReadOnly',
}
